export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-adobe-0798269afad71bb5f49df5dac7e4bc17.svg";